export const RcaConstants = {
  GET_RCA_REQUEST: 'RCA/GET_RCA_REQUEST',
  GET_RCA_SUCCESS: 'RCA/GET_RCA_SUCCESS',
  GET_RCA_ERROR: 'RCA/GET_RCA_ERROR',

  UPDATE_FILTER: 'RCA/UPDATE_FILTER',
  UPDATE_RCA_LIST: 'RCA/UPDATE_RCA_LIST',
  GET_LATEST_REPORT_DATE_REQUEST: 'RCA/GET_LATEST_REPORT_DATE_REQUEST',
  GET_LATEST_REPORT_DATE_SUCCESS: 'RCA/GET_LATEST_REPORT_DATE_SUCCESS',
  GET_LATEST_REPORT_DATE_ERROR: 'RCA/GET_LATEST_REPORT_DATE_ERROR',
  UPDATE_IS_EXTENDED_DATA_AVIALBLE: 'RCA/UPDATE_IS_EXTENDED_DATA_AVIALBLE',
  UPDATE_EXTREME_LEFT_NODE: 'RCA/UPDATE_EXTREME_LEFT_NODE'
};
